import type React from 'react';

import * as st from './styles.module.scss';

type Props = {
	children: React.ReactNode;
};

export const Tabs: React.FC<Props> = ({ children }) => {
	return <div className={st.tabs}>{children}</div>;
};
